// extracted by mini-css-extract-plugin
export default {"Main":"Main_Main__9Uk1t","CardGrid":"Main_CardGrid__vRLgM"};